import { Link } from "react-router-dom";
import { PublicHeader, PublicFooter } from "../components/PublicShell";
import { useSeo } from "../lib/seo";

export default function NotFound() {
  useSeo({ title: "Page not found | DentiCision", path: "/404", noindex: true });
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <PublicHeader />
      <main className="flex-1 max-w-3xl mx-auto px-4 sm:px-6 py-24" data-testid="not-found-page">
        <p className="text-sm font-semibold text-[#1C6FE3]">404</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold text-[#0B2545] mt-2">Page not found</h1>
        <p className="text-slate-600 mt-4">The page you are looking for does not exist or has moved.</p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/" data-testid="not-found-home" className="rounded-full bg-[#1C6FE3] text-white font-semibold px-6 h-11 inline-flex items-center">Go to home</Link>
          <Link to="/guides" data-testid="not-found-guides" className="rounded-full border border-slate-300 text-slate-700 font-semibold px-6 h-11 inline-flex items-center">Browse clinical guides</Link>
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
